module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst formatted = model.formatted || {}\nconst fieldConfig = model.config || {}\nconst tooltips = config.tooltips || {}\nlet disabled = model.disabled || fieldConfig.disabled\nconst invalidValueFound = !!model.dataJSON.code && (!model.dataJSON.from || !model.dataJSON.to)\nconst showUsageTooltip = fieldConfig.showUsageTooltip !== false && config.showUsageTooltip !== false && !disabled\nconst additionalClasses = []\nif(invalidValueFound) additionalClasses.push('warning');\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-field-type=\"timeRangeByCode\" data-field-code=\"<%= model.fieldCode %>\"<%= (disabled ? ' DISABLED' : '') %>>\n<div class=\"code\">\n<input data-field-type=\"text\" type=\"text\" value=\"<%= model.dataJSON.code %>\"<%- (disabled ? ' disabled=\"disabled\"' : ''); %> placeholder=\"<%= model.placeholder || '' %>\"/><%\nif(tooltips.code && showUsageTooltip){\nif(tooltips.code.flavor !== 'default'){\nif(tooltips.code.titleKey){\ntooltips.code.titleKey = String(tooltips.code.titleKey).replace('.default.', `.${tooltips.code.flavor}.`)\n}\nif(tooltips.code.subTitleKey){\ntooltips.code.subTitleKey = String(tooltips.code.subTitleKey).replace('.default.', `.${tooltips.code.flavor}.`)\n}\nif(tooltips.code.messageKey){\ntooltips.code.messageKey = String(tooltips.code.messageKey).replace('.default.', `.${tooltips.code.flavor}.`)\n}\n}\n%><%- include('../../tooltip/tooltip', { model: tooltips.code }); %><%\n}\n%></div>\n<div class=\"rangeLabel\"><%\nif(formatted.from && formatted.to){\n%><div class=\"start\">\n<div class=\"prefix\"><%= __('form.fields.timeRangeByCode.rangeLabel.startPrefix') %></div>\n<%= formatted.from %>\n</div><%\n%><div class=\"end\">\n<div class=\"prefix\"><%= __('form.fields.timeRangeByCode.rangeLabel.endPrefix') %></div>\n<%= formatted.to %>\n</div><%\n} else if(invalidValueFound){\n%><div class=\"warning\">\n<i class=\"fi fi-exclamation-triangle\"></i>\n<%- __('form.fields.timeRangeByCode.invalidCodeGiven') %>\n</div><%\n}\n%></div>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\timeRangeByCode.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const formatted = model.formatted || {}
const fieldConfig = model.config || {}
const tooltips = config.tooltips || {}
let disabled = model.disabled || fieldConfig.disabled
const invalidValueFound = !!model.dataJSON.code && (!model.dataJSON.from || !model.dataJSON.to)
const showUsageTooltip = fieldConfig.showUsageTooltip !== false && config.showUsageTooltip !== false && !disabled
const additionalClasses = []
if(invalidValueFound) additionalClasses.push('warning');

    ; __line = 10
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-type=\"timeRangeByCode\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\"")
    ; __append(escapeFn( (disabled ? ' DISABLED' : '') ))
    ; __append(">\n<div class=\"code\">\n<input data-field-type=\"text\" type=\"text\" value=\"")
    ; __line = 12
    ; __append(escapeFn( model.dataJSON.code ))
    ; __append("\"")
    ; __append( (disabled ? ' disabled="disabled"' : '') )
    ; __append(" placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\"/>")
    ; 
if(tooltips.code && showUsageTooltip){
if(tooltips.code.flavor !== 'default'){
if(tooltips.code.titleKey){
tooltips.code.titleKey = String(tooltips.code.titleKey).replace('.default.', `.${tooltips.code.flavor}.`)
}
if(tooltips.code.subTitleKey){
tooltips.code.subTitleKey = String(tooltips.code.subTitleKey).replace('.default.', `.${tooltips.code.flavor}.`)
}
if(tooltips.code.messageKey){
tooltips.code.messageKey = String(tooltips.code.messageKey).replace('.default.', `.${tooltips.code.flavor}.`)
}
}

    ; __line = 25
    ; __append( include('../../tooltip/tooltip', { model: tooltips.code }) )
    ; 
}

    ; __line = 27
    ; __append("</div>\n<div class=\"rangeLabel\">")
    ; __line = 28
    ; 
if(formatted.from && formatted.to){

    ; __line = 30
    ; __append("<div class=\"start\">\n<div class=\"prefix\">")
    ; __line = 31
    ; __append(escapeFn( __('form.fields.timeRangeByCode.rangeLabel.startPrefix') ))
    ; __append("</div>\n")
    ; __line = 32
    ; __append(escapeFn( formatted.from ))
    ; __append("\n</div>")
    ; __line = 33
    ; 

    ; __line = 34
    ; __append("<div class=\"end\">\n<div class=\"prefix\">")
    ; __line = 35
    ; __append(escapeFn( __('form.fields.timeRangeByCode.rangeLabel.endPrefix') ))
    ; __append("</div>\n")
    ; __line = 36
    ; __append(escapeFn( formatted.to ))
    ; __append("\n</div>")
    ; __line = 37
    ; 
} else if(invalidValueFound){

    ; __line = 39
    ; __append("<div class=\"warning\">\n<i class=\"fi fi-exclamation-triangle\"></i>\n")
    ; __line = 41
    ; __append( __('form.fields.timeRangeByCode.invalidCodeGiven') )
    ; __append("\n</div>")
    ; __line = 42
    ; 
}

    ; __line = 44
    ; __append("</div>\n</div>")
    ; __line = 45
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\timeRangeByCode.ejs

}